export const IDE_WINDOW_TITLE = 'Penrose IDE — penrose-app';

export const MENU_STRIP_ITEMS = [
  'File',
  'Edit',
  'Selection',
  'View',
  'Go',
  'Run',
  'Terminal',
  'Window',
  'Help'
] as const;

export type ActivityIconDef = {
  id: string;
  label: string;
  active?: boolean;
};

/** Left activity bar — Explorer active (ide-mock). */
export const LEFT_ACTIVITY_ICONS: ActivityIconDef[] = [
  { id: 'ex', label: 'EX', active: true },
  { id: 'sr', label: 'SR' },
  { id: 'git', label: 'GIT' },
  { id: 'run', label: 'RUN' },
  { id: 'ext', label: 'EXT' },
  { id: 'spacer', label: '' },
  { id: 'p', label: 'P' }
];

/** Right activity bar — Penrose active at top. */
export const RIGHT_ACTIVITY_ICONS: ActivityIconDef[] = [
  { id: 'p', label: 'P', active: true },
  { id: 'ex', label: 'EX' },
  { id: 'sr', label: 'SR' },
  { id: 'git', label: 'GIT' }
];

export const FILE_TREE = [
  { depth: 0, label: '▾ penrose-app' },
  { depth: 1, label: '▸ src' },
  { depth: 1, label: '▸ tests' },
  { depth: 1, label: 'package.json' },
  { depth: 1, label: 'README.md' }
] as const;
